// extracted by mini-css-extract-plugin
export var captionWrap = "caption-module--captionWrap--XISGt";
export var fullOpacity = "caption-module--fullOpacity--8yc7r";
export var captionText = "caption-module--captionText---zx83";
export var creditText = "caption-module--creditText--RP914";
export var slideUp = "caption-module--slideUp--yITFv";
export var slideUpLarge = "caption-module--slideUpLarge--7BqzK";